export default __webpack_public_path__ + "static/media/imagethree.9179a20a.png";